import {get,post} from "../../../../DAL/data-provider";

export const getPresetsPage = async (handle:  string | null, pageIndex:number) => {
    return get('/api/olp/get-creator-presets?handle=' + handle + "&pageIndex=" + pageIndex);
};
export const getTagPresetsPage = async (tag:  string | null, pageIndex:number) => {
    return get('/api/olp/get-tag-presets?tag=' + tag + "&pageIndex=" + pageIndex);
};
export const getPluginPresetsPage = async (tag:  string | null, pageIndex:number) => {
    return get('/api/olp/get-plugin-presets?tag=' + tag + "&pageIndex=" + pageIndex);
};
export const setUserLikeClick = async (presetGuid:  string) => {
    const postData = {
        PresetGuid: presetGuid
    }
    return post('/api/olp/user-like',postData);
};

